export const footer = `
<footer
  id="footer"
  style="width: 100%; font-size: 12px; display: table; margin-top: 20px"
>
  <div
    style="display: table-cell; padding-left: 20px;"
    id="footer_left"
  >
    <span>{{ client.footer_text }}</span>
  </div>
  <div
    style="display: table-cell; text-align: right; padding-right: 20px;"
    id="footer_right"
  >
    {% if client.phone | filled %}
      <span>
        Telephone: <a
          href="tel:{{ client.phone }}"
          target="_blank"
        >{{ client.phone }}</a>
      </span>
    {% endif %}
    {% if client.email | filled %}
      <span
      >
        Email: <a
          href="mailto:{{ client.email }}"
          target="_blank"
        >{{ client.email }}</a>
      </span>
    {% endif %}
    {% if client.footer_website | filled %}
      {% if client.email | filled %}
        <span> - </span>
      {% endif %}
      <span>
        <a
          href="{{ client.footer_website }}"
          target="_blank"
        >
          {{ client.footer_website }}
        </a>
      </span>
    {% endif %}
  </div>
</footer>
`

export const footerStyles = `
  #footer {
    width: 100%;
    font-size: 12px;
    display: table;
  }

  .table-cell {
    display: table-cell;
  }

  .pr-20 {
    padding-right: 20px;
  }

  .pl-20 {
    padding-left: 20px;
  }

  .mt-20 {
    margin-top: 20px;
  }
`;
